import * as angular from "angular";
import { Group } from "../../models/group.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { PermissionCheck } from "../../shared/permission";

let GroupSelectionDialogComponent = {
    selector: "vcGroupSelectionDialog",
    templateUrl:
        "/angular/components/group/group-selection-dialog.component.html",
    bindings: {
        provider: "=",
        street: "=?",
    },
    controller: class GroupSelectionDialogController {
        // * bindings for typescript compiler *
        private provider: any;
        // ************************************

        public searchText = "";
        public groups: Group[] | null = null;
        public selectedGroup: Group | undefined;

        private $scope: object;
        private dialog: DialogUtils;
        private modelsUtils: any;
        private street: any;
        private permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            GroupDataProvider: GroupDataProvider,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.permissionProvider = PermissionCheck;

            GroupDataProvider.getAllGroups().then((groups: Group[]) => {
                this.groups = groups.filter(
                    (group: Group) => !group.fid && !group.points
                );
            });
        }

        searchGroups(searchText: string): Group[] | null {
            return searchText && searchText != ""
                ? this.groups.filter((obj: Group) => {
                      return (
                          obj["gname"]
                              .toLowerCase()
                              .indexOf(searchText.toLowerCase()) != -1
                      );
                  })
                : this.groups;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        ok(): void {
            if (this.provider && this.provider.checkManager) {
                this.provider.checkManager.setLoading(true);
            }
            this.dialog.hide(this.selectedGroup);
        }

        openGroupDialog(groupname: string, ev: object): void {
            //hack to stop the autocomplete matches covering the create group dialog.
            let autoChild =
                document.getElementById("groupAutoComplete").firstElementChild;
            let el = angular.element(autoChild);
            (el.scope() as any).$mdAutocompleteCtrl.hidden = true;
            (el.scope() as any).$mdAutocompleteCtrl.blur();
            this.dialog
                .show({
                    component: "vc-create-group",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        group: this.modelsUtils.group({
                            gname: groupname,
                            gstatus: this.permissionProvider.hasPermission(
                                "APPROVAL_NEEDED"
                            )
                                ? "Pending"
                                : "Active",
                        }),
                        assign: false,
                        autoSplitAssign: false,
                        listViewDataProvider: this.provider,
                        street: this.street,
                    },
                })
                .then((newGroup: Group) => {
                    newGroup.created = true;
                    if (this.provider && this.provider.checkManager) {
                        this.provider.checkManager.setLoading(true);
                    }
                    this.dialog.hide(newGroup);
                });
        }
    },
};

angular
    .module("group")
    .component(
        GroupSelectionDialogComponent.selector,
        GroupSelectionDialogComponent
    );
